export default __webpack_public_path__ + "static/reactfiles/br.504e672f.svg";